/* ログ一覧検索結果リスト */
import React, { useState, memo } from 'react';
import { Grid, _ } from 'gridjs-react';
var LogResultList = function (_a) {
    var projects = _a.projects, config = _a.config;
    var _b = useState(10), rows = _b[0], setRows = _b[1];
    var onChangeLimit = function (event) {
        setRows(Number(event.target.value));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row my-2" },
            React.createElement("div", { className: "col-md-12" },
                React.createElement("span", { className: "search-criteria-head" }, "\u8868\u793A\u4EF6\u6570"),
                React.createElement("select", { name: "\u8868\u793A\u4EF6\u6570", className: "search-form-input", onChange: onChangeLimit, value: rows }, config.display_list_number.map(function (num, index) {
                    return (React.createElement("option", { key: index, value: num }, num));
                })))),
        React.createElement(Grid, { data: projects, columns: [
                {
                    id: 'created_at',
                    name: '時間',
                    width: '100px',
                },
                {
                    id: 'user_id',
                    name: 'ユーザ名',
                    width: '80px',
                },
                {
                    id: 'message_code',
                    name: 'メッセージID',
                    width: '80px',
                },
                {
                    id: 'message',
                    name: 'メッセージ',
                    width: '350px',
                    formatter: function (cell) {
                        return _(cell === null || cell === void 0 ? void 0 : cell.toString().split('\\n').map(function (x) { return React.createElement("div", null, x); }));
                    },
                },
                {
                    id: 'src_address',
                    name: '接続情報',
                    width: '110px',
                },
            ], search: false, sort: true, pagination: {
                enabled: true,
                limit: rows,
            }, fixedHeader: true, height: "600px" })));
};
export default memo(LogResultList);
